import React from 'react'
import { useDispatch } from 'react-redux'
import { showModal } from 'store/slices/miscSlice'
import HeaderComponent from 'components/HeaderComponent'
import AddCashback from './AddCashback'
import { CashbackValidation } from 'pages/Settings/validation'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function CashbackHeader({ t }) {
  const dispatch = useDispatch()

  return (
    <HeaderComponent
      title={t('settings.cashback.cashback')}
      btnText={t('settings.cashback.add')}
      btnClick={() => dispatch(showModal({
        title: t('settings.cashback.add'),
        content: AddCashback,
        validation: CashbackValidation,
        url: 'settings/cashbacks',
        method: 'post',
        successMsg: t('settings.cashback.created')
      }))}
      showSearch={true}
    />
  )
})
